enum TableSelectColumnType {
    text = 0,

    link = 1
}

export default TableSelectColumnType;